import { useContext, useState, useEffect, useRef } from 'react';
import { Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const DayCloseReport = () => {
    const { getDate, getLoad, setGetLoad, downloadExcel, makePostCall, link, accessToken, setAuthForm,
        setDayCloseReportModal, setCloseDayReport, setGetDayReportload } = useContext(AppContext);
    const [report, setReport] = useState();
    const [filename, setFilename] = useState('report_day_close');
    const effectRan = useRef(false);
    useEffect(() => {
        if (effectRan.current === false) {
            const today = getDate();
            if (today) {
                getReportCall(today, today, "");
            }
        }
        return () => {
            effectRan.current = true;
        }
    }, []);
    const getReportCall = (start, end, staff) => {
        setGetLoad(true);
        makePostCall(link, 'api/bnr/get/day/close/report/', { start_date: start, end_date: end, staff: staff }, accessToken, setAuthForm)
            .then(res => {
                setGetLoad(false);
                setReport(res.data);
                setFilename(`report_day_close_from_${start}_to_${end}`);
            })
            .catch(() => setGetLoad(false));
    }
    const getReport = (e) => {
        e.preventDefault();
        let start = e.target.start.value;
        let end = e.target.end.value;
        let staff = e.target.staff.value;
        if (start !== "" && end !== "") {
            getReportCall(start, end, staff);
        }
    }
    const tableRef = useRef(null);
    const formatExcel = () => {
        if (report !== undefined && Object.keys(report).length > 0) {
            let data = [];
            Object.keys(report).map(item => {
                data.push({
                    'Date': report[item].date,
                    'Time': report[item].time,
                    'Staff': report[item].staff_name,
                    'Total Cash': report[item].day_total,
                    'Opening': report[item].opening,
                    'Closing': report[item].closing,
                    'Diffrence': (parseFloat(report[item].closing) - parseFloat(report[item].day_total)).toFixed(2),
                    'Reason': report[item].reason,
                });
            });
            return data;
        }
    }
    const detailReport = (bid) => {
        if (bid) {
            setGetDayReportload(true);
            setDayCloseReportModal(true);
            makePostCall(link, 'api/bnr/get/day/close/details/', { dc_id: bid.substring(1) }, accessToken, setAuthForm)
                .then(res => {
                    setGetDayReportload(false);
                    setCloseDayReport(res.data);
                })
                .catch(() => setGetDayReportload(false));
        }
    }
    return (
        <div className='container-fluid'>
            <div className='bgp grid4by6 align-items-center justify-content-between p-2 br-3 mb-2'>
                <div className="d-grid px-2">
                    {
                        getLoad ? (
                            <span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
                        ) : (
                            <span className='text-white ' >Day Close Report</span>
                        )
                    }
                </div>
                <Form onSubmit={getReport} >
                    <Row className="d-flex" >
                        <Col xs={12} sm={4} md={3} >
                            <InputGroup className="br-3">
                                <InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
                                <Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={4} md={3} >
                            <InputGroup className="br-3">
                                <InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
                                <Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={4} md={3} >
                            <Form.Select name="staff" className="shadow-none br-2">
                                <option value="" >All staffs</option>
                                {
                                    report !== undefined ? (
                                        report.users !== undefined ? (
                                            Object.keys(report.users).length > 0 ? (
                                                Object.keys(report.users).map((staff, staff_i) => (
                                                    <option value={staff.substring(1)} key={`user_${staff_i}`} >{report.users[staff].username}</option>
                                                ))
                                            ) : ''
                                        ) : ''
                                    ) : ''
                                }
                            </Form.Select>
                        </Col>
                        <Col xs={12} sm={4} md={3} className="d-grid" >
                            <Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            {
                report !== undefined && report.bills !== undefined && Object.keys(report.bills).length > 0 ? (
                    <div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
                        <span>Download</span>
                        <Button className="br-1" onClick={() => {
                            downloadExcel(formatExcel(), `${filename}.xlsx`);
                        }} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
                        <Button onClick={() => {
                            $('.view-bill-link').addClass('hide');
                            generatePDF(tableRef, { filename: `${filename}.pdf` });
                            $('.view-bill-link').removeClass('hide');
                        }} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
                        <ReactToPrint
                            trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
                            content={() => tableRef.current}
                            onBeforeGetContent={() => {
                                return new Promise((resolve) => {
                                    $('.view-bill-link').addClass('hide');
                                    resolve();
                                });
                            }}
                            onAfterPrint={() => {
                                $('.view-bill-link').removeClass('hide');
                            }}
                        />
                    </div>
                ) : null
            }
            <div ref={tableRef}>
                <Table bordered className="tbl-bg-blue">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Staff</th>
                            <th className="text-end" >Total Cash</th>
                            <th className="text-end" >Opening ( in cash )</th>
                            <th className="text-end" >Closing ( in cash )</th>
                            <th className="text-end" >Diffrence</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            report !== undefined && Object.keys(report).length > 0 ? (
                                Object.keys(report).map((item, i) => (
                                    <tr>
                                        <td>
                                            <div className='d-grid'>
                                                <div className='d-flex'>
                                                    <span onClick={() => { detailReport(item) }} className="view-bill-link" ><i className="bi bi-info-circle"></i> Details</span>
                                                </div>
                                                <span className="tp2 f14" >{report[item].date}</span>
                                                <span className='tp2 f12' >{report[item].time}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <span className='tp2' >{report[item].staff_name}</span>
                                        </td>
                                        <td className='text-end' ><span className="tp2">{report[item].day_total}</span></td>
                                        <td className='text-end' ><span className='tp2' >{report[item].opening}</span></td>
                                        <td className='text-end' ><span className='tp2' >{report[item].closing}</span></td>
                                        <td className='text-end' >
                                            {
                                                (parseFloat(report[item].day_total) - parseFloat(report[item].closing)) === 0 ? (
                                                    <span className='tp2' >0.00</span>
                                                ) : (parseFloat(report[item].day_total) < parseFloat(report[item].closing)) ? (
                                                    <div className='d-grid'>
                                                        <span className='tp2 text-success' >+{(parseFloat(report[item].closing) - parseFloat(report[item].day_total)).toFixed(2)} ( Excess ) </span>
                                                        <span className='tp2 f14' >{report[item].reason}</span>
                                                    </div>
                                                ) : (parseFloat(report[item].day_total) > parseFloat(report[item].closing)) ? (
                                                    <div className='d-grid'>
                                                        <span className='tp2 text-danger' >{(parseFloat(report[item].closing) - parseFloat(report[item].day_total)).toFixed(2)} ( Short )</span>
                                                        <span className='tp2 f14' >{report[item].reason}</span>
                                                    </div>
                                                ) : null
                                            }

                                        </td>
                                    </tr>
                                ))
                            ) : ''
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}